// extracted by mini-css-extract-plugin
export default {"legend":"chartLegend__legend___rO0mx","line":"chartLegend__line___47kJY","axisLabel":"chartLegend__axisLabel___0x3dB","additionalValue":"chartLegend__additionalValue___GcXsn"};